import { readable, writable } from 'svelte/store';

//User language
const stored_current_lang = localStorage.getItem("current_lang");
export const current_lang = writable(stored_current_lang);
current_lang.subscribe(value => {
    localStorage.setItem("current_lang", value);
});

//Remember installation notice closing
const stored_installation_notice_status = localStorage.getItem("installation_notice_status");
export const installation_notice_status = writable(stored_installation_notice_status);
installation_notice_status.subscribe(value => {
    localStorage.setItem("installation_notice_status", value);
});

//Remember scrolling (used in schedule views)
export const x_scroll_pos_history = writable(null);
export const y_scroll_pos_history = writable(null);

//News api stuff
export const news_api_storage = writable(null);
export const news_cats_api_storage = writable(null);

//Artist api stuff
export const artists_api_storage = writable(null);
export const venues_api_storage = writable(null);

//UI translations
export const translations = readable({
    "EAT_AND_DRINK": {
        "FI":   "Syö ja juo",
        "EN":   "Eat & Drink"
    },
    "NEWS": {
        "FI":   "Ajankohtaista",
        "EN":   "News"
    },
    "MAIN_CONCERTS": {
        "FI":   "Pääkonsertit",
        "EN":   "Main concerts"
    },
    "OTHER_EVENTS": {
        "FI":   "Muu ohjelma",
        "EN":   "Other events"
    },
    "PROGRAM": {
        "FI":   "Ohjelma",
        "EN":   "Program"
    },
    "MAP": {
        "FI":   "Kartta",
        "EN":   "Map"
    },
    "PARTNERS": {
        "FI":   "Kumppanit",
        "EN":   "Partners"
    },
    "LOADING_NEWS": {
        "FI":   "Ladataan uutisia",
        "EN":   "Loading news"
    },
    "LOADING_ARTICLE": {
        "FI":   "Ladataan artikkelia",
        "EN":   "Loading article"
    },
    "TIME": {
        "FI":   "Aika",
        "EN":   "Time"
    },
    "ARTIST": {
        "FI":   "Esiintyjä",
        "EN":   "Artist"
    },
    "SETTINGS": {
        "FI":   "Asetukset",
        "EN":   "Settings"
    },
    "LANGUAGE": {
        "FI":   "Kieli",
        "EN":   "Language"
    },
    "ERROR": {
        "FI":   "Virhe",
        "EN":   "Error"
    },
    "CONTENT_NOT_FOUND": {
        "FI":   "Sisältöä ei löytynyt",
        "EN":   "Not found"
    },
    "RETURN_TO_MAIN_MENU": {
        "FI":   "Palaa päävalikkoon",
        "EN":   "Return to main menu"
    },
    "COUNTDOWN_TO_FESTIVAL": {
        "FI":   "Festivaalin alkuun",
        "EN":   "Countdown to festival"
    },
    "TIME_DAYS": {
        "FI":   "pv",
        "EN":   "d"
    },
    "TIME_HOURS": {
        "FI":   "h",
        "EN":   "h"
    },
    "TIME_MINUTES": {
        "FI":   "min",
        "EN":   "min"
    },
    "TIME_SECONDS": {
        "FI":   "s",
        "EN":   "s"
    },
    "ROTATE_DEVICE": {
        "FI":   "Käännä laitteesi pystyasentoon.",
        "EN":   "Please rotate your device."
    },
    "BUY_TICKETS": {
        "FI":   "Osta liput",
        "EN":   "Buy tickets"
    },
    "SEE_YOU_NEXT_YEAR": {
        "FI":   "Nähdään ensi vuonna!",
        "EN":   "See you next year!"
    },
    "PIC_NOT_LOADED_OFFLINE": {
        "FI":   "Sovellus on offline-tilassa. Kuvaa ei ole ladattu.",
        "EN":   "The application is offline. Image has not been downloaded.",
    },
    "INSTRUCTIONS": {
        "FI":   "Ohjeet",
        "EN":   "Instructions"
    },
    "INSTALLATION": {
        "FI":   "Asentaminen",
        "EN":   "Installation"
    },
    "SHOW_INSTALLATION_INSTRUCTIONS": {
        "FI": "Näytä asennusohjeet",
        "EN": "Show instructions",
    },
    "CHOOSE_YOUR_OS": {
        "FI": "Valitse käyttöjärjestelmäsi",
        "EN": "Choose your OS",
    },
    "INFO": {
        "FI": "Info",
        "EN": "Info"
    }
});

//Festival days used in schedule views
export const festival_days = readable([
    {
        "daytype":     "normal",
        "date":     "2023-07-07",
    },
    {
        "daytype":   "normal",
        "date":     "2023-07-08",
    },
    {
        "daytype":   "normal",
        "date":     "2023-07-09",
    },
    {
        "daytype":   "normal",
        "date":     "2023-07-10",
    },
    {
        "daytype":   "normal",
        "date":     "2023-07-11",
    },
    {
        "daytype":   "normal",
        "date":     "2023-07-12",
    },
    {
        "daytype":   "main",
        "date":     "2023-07-13",
    },
    {
        "daytype":   "main",
        "date":     "2023-07-14",
    },
    {
        "daytype":   "main",
        "date":     "2023-07-15",
    },
]);

//Main venue IDs used in schedule views (venues with these IDs are shown in main concerts section)
export const main_venue_ids = readable(
    [11, 12, 13, 215]
);

//Festival start and end time
export const festival_time = readable(
    {
        "start": "2023-07-07 18:00:00",
        "end": "2023-07-16 08:00:00"
    },
);